import { render, staticRenderFns } from "./ViewResourceViews.modal.vue?vue&type=template&id=1bfba92c&scoped=true"
import script from "./ViewResourceViews.modal.vue?vue&type=script&lang=ts"
export * from "./ViewResourceViews.modal.vue?vue&type=script&lang=ts"
import style0 from "./ViewResourceViews.modal.vue?vue&type=style&index=0&id=1bfba92c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfba92c",
  null
  
)

export default component.exports